module.exports = __webpack_public_path__ + "static/media/n-genius.6763bd20.png";